import { render, staticRenderFns } from "./ReturnCancelPayment.vue?vue&type=template&id=5b6955e9&scoped=true"
import script from "./ReturnCancelPayment.vue?vue&type=script&lang=js"
export * from "./ReturnCancelPayment.vue?vue&type=script&lang=js"
import style0 from "./ReturnCancelPayment.vue?vue&type=style&index=0&id=5b6955e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6955e9",
  null
  
)

export default component.exports